export default __webpack_public_path__ + "static/media/Strangler's Belt of the Grim Cabal.0ed2125f.jpg";